<template>
  <div>
    <NuxtLoadingIndicator v-if="!route.name.startsWith('fat')" />
    <ClientOnly>
      <div class="!text-2xs fixed z-[999] bottom-2 right-2 opacity-0 hover:opacity-100" v-if="route.name !== 'start'">
        <a href="/?cityId=null" class="text-xs">Start</a>
      </div>
    </ClientOnly>
    <!-- <div class="debug !text-2xs fixed z-[999] bottom-2 right-2 !bg-gray-100">
      pageviews: {{ app.pageviews }}
      <br>
      name: {{ route.name }}
      <hr class="my-2">
      pending: {{ fat.pending }}
      <br>
      total: {{ fat.total }}
      <hr class="my-2">
      city: {{ fat.city?.name }}
      <br>
      cityId: {{ fat.cityId }}
      <br>
      cityIds: {{ fat.cityIds?.join(',') }}
      <hr class="my-2">
      timeRange: {{ fat.timeRange || 'null' }}
      <br>
      preferredTime: {{ fat.preferredTime || 'null' }}
      <br>
      date: {{ fat.date }}
      <br>
      amount: {{ fat.amount }}
      <br>
      exEmpt: {{ fat.excludeEmpty }}
      <br>
      restaurantIds: {{ fat.restaurantIds?.length }}
    </div> -->
    <Head>
      <Title>{{ $t('shared.meta.title') }}</Title>
      <Meta name="description" :content="$t('shared.meta.description')" />
      <Meta name="og:image" :content="useFullPath('bokabord-share.jpg')" />
      <Link rel="canonical" :href="canonical" />
    </Head>
    <AppBanners />
    <AppHeader />
    <AppDrawer />
    <FatDrawer />
    <NuxtPage />
    <Widget />
    <Preview />
    <AppLocation />
    <AppFooter />
  </div>
</template>

<script setup>
const route = useRoute()
const router = useRouter()
const app = useAppStore()
const fat = useFatStore()

// Init default values for FAT
fat.initFromConfig()

// Create canonical, without query params, but with paged 
const canonical = computed(() => route?.query?.paged
  ? useFullPath(route.path) + `?paged=${route?.query?.paged}`
  : useFullPath(route.path))

// Increment page views in config
watch(() => route.query, () => {
  app.addPageview()
})

// Add initial page view and smooth scrolling behavior 
onMounted(() => {
  app.addPageview()
})

// Cleanup listener to avoid memory leaks
onUnmounted(() => {
  router.afterEach(() => {})
})

// Toggle no-scroll class on body
useHead({
  htmlAttrs: {
    class: computed(() => {
      return [
        route.name === 'start' ? 'startpage' : '',
      ].filter(Boolean).join(' ')
    })
  },
  bodyAttrs: {
    class: computed(() => app.lockScroll ? 'no-scroll' : '')
  }
})
</script>